import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';

// material
import { styled, alpha } from '@mui/material/styles';
import { Box, Button, Drawer, Typography, Avatar, Collapse } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

// mocks_
// hooks
import useResponsive from '../../hooks/useResponsive';

// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import Iconify from '../../components/Iconify';

//
import { api } from 'src/Api';
import { Decryption } from 'src/functions/function';
import palette from '../../theme/palette';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 250;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
    backgroundColor: alpha(theme.palette.drawerBackground, 1)
  }
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const [open, setOpen] = useState(false);
  const [sideBar, setsideBar] = useState([]);

  const handleProfileClick = () => {
    setOpen(!open);
  };

  function Logout() {
    const rememberEmail = localStorage.getItem('email');
    const rememberPassword = localStorage.getItem('password');
    const rememberMe = localStorage.getItem('remember');

    // Clear all local storage
    localStorage.clear();

    // Re-set remembered credentials
    if (rememberMe === 'true') {
      localStorage.setItem('email', rememberEmail);
      localStorage.setItem('password', rememberPassword);
      localStorage.setItem('remember', rememberMe);
    }

    navigate('/login', { replace: true });
  }
  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    function getSideBar() {
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${token}`);
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(api.sidebar, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error('Failed to fetch sidebar data');
          }
        })
        .then((result) => {
          let decryptedData = Decryption(result.data);

          setsideBar(decryptedData);
          console.log(decryptedData, 'YE CHECK KRW');
          localStorage.setItem('permissions', JSON.stringify(decryptedData));
        })
        .catch((error) => {
          console.log('error', error);
        })
        .finally(() => {});
    }
    getSideBar();
  }, []);
  const renderContent = (
    <Box
      sx={{
        height: 1,
        display: 'flex',
        backgroundColor: palette.drawerBackground,
        flexDirection: 'column',
        borderWidth: 1
      }}
    >
      <Box
        sx={{
          px: 4,
          py: 2,
          pt: 3,
          display: 'inline-flex',
          backgroundColor: palette.drawerBackground
        }}
      >
        <Logo />
      </Box>

      <Scrollbar
        sx={{
          flex: 1,
          backgroundColor: palette.drawerBackground,
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <NavSection navConfig={sideBar} />
      </Scrollbar>

      <Box
        style={{
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          padding: '10px 5px 10px 5px',
          backgroundColor: 'rgba(255,255,255,0.2)'
        }}
      >
        {user && (
          <Box
          // sx={{
          //   bgcolor: '#edf2f4'
          // }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              // onClick={handleProfileClick}
            >
              <Avatar
                style={{ width: 34, height: 34, marginLeft: 3 }}
                alt={user?.name || 'User Avatar'}
                src={user.avatar}
              />

              <Box sx={{ flex: 1, ml: 1 }}>
                <Typography
                  variant="overline"
                  sx={{
                    fontSize: 12,
                    textTransform: 'capitalize',
                    color: '#f90001'
                    // backgroundColor: 'green'
                  }}
                >
                  {/* {`${user.first_name} ${user.last_name}`}|| */}

                  {user?.name}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: 11, color: '#f90001', paddingTop: -3 }}>
                  {user.email}
                </Typography>
              </Box>
              {/* {open ? (
                <ExpandLess sx={{ color: '#f90001', fontSize: 18 }} />
              ) : (
                <ExpandMore sx={{ color: '#f90001', fontSize: 18 }} />
              )} */}
            </Box>
            <Box>
              {/* <Collapse in={open}> */}
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '5px 0px 5px 5px',
                    margin: '7px 2px 7px 2px',
                    borderTop: '1px solid rgba(255,255,255,0.4)',
                    borderBottom: '1px solid rgba(255,255,255,0.4)',
                    marginTop: 2
                    // backgroundColor: 'blue'
                  }}
                >
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#f90001'
                    }}
                  >
                    Log Out
                    {/* {user?.role?.role_name} */}
                  </Typography>
                  <Iconify
                    onClick={Logout}
                    style={{ fontSize: 22, color: '#f90001', cursor: 'pointer' }}
                    icon="solar:logout-broken"
                  />
                </Box>

                {/* <Button
                  variant="contained"
                  color="primary"
                  style={{ marginRight: 10, width: '45%', fontSize: 10 }}
                  component={RouterLink}
                  to="/dashboard/edit_profile"
                >
                  Edit Profile
                </Button> */}
                {/* <Button
                  variant="contained"
                  color="primary"
                  style={{ width: '50%', fontSize: 10 }}
                  component={RouterLink}
                  to="/dashboard/settings"
                >
                  Account Settings
                </Button> */}
              </Box>
              {/* </Collapse> */}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH, bgcolor: 'background.default' }
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed'
            }
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
